<div class="dount-chart-parent">
    <app-viz-wrapper [widgetId]="widgetId" [vizConfig]="visualizationModel" [vizInfo]="vizInfo"></app-viz-wrapper>
</div>